export default "__VITE_PUBLIC_ASSET__7035b9b1__"